// extracted by mini-css-extract-plugin
module.exports = {"slide":"TabOverTime_slide_3IU9Y","slide-reverse":"TabOverTime_slide-reverse_1YYFg","content":"TabOverTime_content_20I4F","timeDisplay":"TabOverTime_timeDisplay_12Ssm"};